module.exports = __webpack_public_path__ + "img/pin.e8f470a5.png";